import angular from 'angular';
import adminpulse from '../../../shared/utils/adminpulse';
angular.module('cloudX').directive('uibDatepickerPopup', function() {
  var directive = {
    restrict: 'A',
    require: ['ngModel'],
    link: link,
    priority: 1,
  };
  return directive;

  function link(scope, element, attr, ctrls) {
    var ngModelController = ctrls[0];
    if (!attr.uibDatepickerPopup) return;
    if (attr.uibDatepickerPopup !== 'dd/MM') return;

    // if (attr.datepickerOptions) {
    //   const options = scope.$eval(attr.datepickerOptions);
    //   if (options && !!options.minDate) return; //Don't run parsers if mindate is set
    // }

    ngModelController.$parsers.push(function(viewValue) {
      if (!viewValue) return viewValue;

      if (angular.isDate(viewValue)) return adminpulse.dayMonthDate(viewValue);
      return viewValue;
    });
  }
});
